import React from 'react';
import HelmetContainer from '../../components/common/helmet/helmet';
import Layout from '../../components/layout/layout';
import PromotionDetailsContainer from '../../components/promotion-details/promotion-details-container/promotion-details-container';
import PromotionTransactions from '../../components/promotion-details/promotion-transactions/promotion-transactions';
import FeaturePromotion from '../../components/promotions/feature-promotion/feature-promotion';

function PromotionsDetails() {
  return (
    <Layout showborder={true}>
      <HelmetContainer title="Promotion" />
      <div className="page__row">
        <div className="page__col">
          <PromotionDetailsContainer />
        </div>
        <div className="page__col page__col_pt198">
          <div className="promotions promotions_flex">
            <PromotionTransactions />
            <div className="promotions__wrap">
              <FeaturePromotion />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default PromotionsDetails;
